'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _payments = require('../redux/modules/payments');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  checkout: function checkout(state, action) {
    switch (action.type) {
      case _payments.GET_PRICE:
        return (0, _extends3.default)({}, state, {
          previousCountry: state.country && state.country.value
        }, state.previousCountry && state.country && state.previousCountry !== state.country.value && { vatNo: {} });

      default:
        return state;
    };
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/formPlugin.js
// module id = 2176
// module chunks = 0